<div
  class="c column"
  *ngIf="form && definition"
>
  <label class="soft-label top"
    >{{ definition.title }}
    <span
      class="required-indicator"
      *ngIf="definition.required | booleanRule: form.value"
      >*</span
    >
  </label>
  <soft-draw-input
    [formControl]="form|formControl:definition.name"
    [readonly]="definition.readonly | booleanRule: form.value"
    softFieldValidation
  >
  </soft-draw-input>
</div>
